import { NeoModel } from "@singularsystems/neo-core";
import { Views } from "@singularsystems/neo-react";
import Types from "../../../App/AppTypes";
import { AppService } from "../../../App/Services/AppService";
import CorporateActionEventCompleteLookup from "../Models/Lookups/CorporateActionEventCompleteLookup";

@NeoModel
export default class CompleteCorporateActionEventComponentVM extends Views.ViewModelBase {
    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public corporateActionEventsApiClient = AppService.get(Types.ApiClients.CorporateActionEventsApiClient),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {
        super(taskRunner);
    }
    public completeCorporateActionEvent = new CorporateActionEventCompleteLookup();
}